
import React from 'react';
import loadable from '@loadable/component';
import ResultUI from '../componentsUI/Result';
import SpinUI from '../componentsUI/Spin';
import { DialogPresentation } from '../componentsUI/Dialog/dialogPresentation';
import { getDynamicViewportHeightCalc } from './viewportHeight';
import './dialogLazyLoad.less';

interface LoadingDialogComponentProps {
    error?: unknown;
    timedOut: boolean;
    pastDelay: boolean;
    presentation?: DialogPresentation;
}

// https://github.com/gregberge/loadable-components/pull/226
function load(fn, loadableOptions, dialogOptions?: {
    presentation?: DialogPresentation;
}) {
    const loadWithFallback = (props) =>
        Promise.resolve(fn(props)).catch((error) => {
            console.error(error);

            return {
                default: () => (
                    <LoadingDialogComponent
                        pastDelay={true}
                        error={error}
                        timedOut={false}
                        presentation={dialogOptions?.presentation}
                    />
                ),
            };
        });
    const Component = loadable(loadWithFallback, loadableOptions);

    Component.preload = fn.requireAsync || fn;
    return Component;
}

function LoadingDialogComponent(props: LoadingDialogComponentProps) {
    const forceMobileShell =
        typeof document !== "undefined" &&
        document.body?.dataset.mobileCenteredShellActive === "true";

    // position: absolute;
    // right: 0;
    // top: 0;
    // width: 520px;
    // height: 700px;
    return (
        <div
            className='dialog-plus-page dialog-plus-loading'
            data-dialog-presentation={props.presentation || 'page'}
            data-dialog-lazy-state={props.error ? 'error' : 'loading'}
            style={{
                position: props.presentation === 'modal-card' ? 'relative' : forceMobileShell ? 'absolute' : 'fixed',
                top: props.presentation === 'modal-card' ? undefined : 0,
                left: props.presentation === 'modal-card' ? undefined : 0,
                right: props.presentation === 'modal-card' ? undefined : 0,
                bottom: props.presentation === 'modal-card' ? undefined : 0,
                height: props.presentation === 'modal-card' ? getDynamicViewportHeightCalc(24) : '100%',
                width: props.presentation === 'modal-card' ? '100%' : '100%',
                maxWidth:
                    props.presentation === 'modal-card'
                        ? forceMobileShell
                            ? 'calc(100% - 24px)'
                            : '408px'
                        : undefined,
                maxHeight:
                    props.presentation === 'modal-card'
                        ? forceMobileShell
                            ? 'calc(100% - 24px)'
                            : '680px'
                        : undefined,
                borderRadius: props.presentation === 'modal-card' ? 'var(--skin-dialog-radius, 20px)' : undefined,
            }}>
            {props.error ? <ResultUI status="error" /> : <SpinUI dot={true} />}
        </div>

    );
}

export default (
    loader,
    options?: {
        presentation?: DialogPresentation;
    }
) =>
    load(loader, {
        fallback: LoadingDialogComponent({
            pastDelay: true,
            error: false,
            timedOut: false,
            presentation: options?.presentation,
        }),
    }, options);

